<template>
	<div>
		<settings-alerts
			:isError="isError"
			:isSuccess="isSuccess"
			@toggleSucces="(value) => (isSuccess = value)"
			@toggleError="(value) => (isError = value)"
		/>
		<div class="subtitle-1 grey--text text--darken-2 font-weight-bold mb-8">
			{{ $vuetify.lang.t("$vuetify.views.settings.account.avatar") }}
		</div>
		<div class="d-flex align-center">
			<avatar :hideActivity="true" :bg="true" :isRoute="false" />
			<div class="ml-6">
				<div>
					<v-btn
						@click="$refs.attachments.dialog = true"
						class="mr-4"
						color="accent"
						elevation="0"
						height="32"
					>
						<v-icon class="mr-2">$photo</v-icon>
						{{
							$vuetify.lang.t(
								"$vuetify.views.settings.account.changeAvatar"
							)
						}}
					</v-btn>
					<v-btn
						@click="deleteAvatar(false)"
						class="grey--text text--darken-2"
						elevation="0"
						height="32"
					>
						{{
							$vuetify.lang.t(
								"$vuetify.views.settings.account.deleteAvatar"
							)
						}}
					</v-btn>
				</div>
				<p class="grey--text caption my-0 mt-4 avatar-instruction">
					{{
						$vuetify.lang.t(
							"$vuetify.views.settings.account.avatarInfo"
						)
					}}
				</p>
			</div>
		</div>

		<attach-image-dialog
			@selected="updateImage"
			ref="attachments"
			:result-width="600"
		/>
	</div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

import Avatar from "@/components/Avatar";
import SettingsAlerts from "@/components/settings/SettingsAlerts";
import AttachImageDialog from "@/components/wall/dialogs/AttachImageDialog";

export default {
	name: "AvatarSettings",
	components: {
		Avatar,
		AttachImageDialog,
		SettingsAlerts,
	},

	data() {
		return {
			isSuccess: false,
			isError: false,
		};
	},

	computed: {
		...mapGetters({
			user: "auth/user",
			isAvatarLoading: "auth/isAvatarLoading",
		}),
	},

	methods: {
		async updateImage(img) {
			let res;

			this.$store.commit("auth/setAvatarLoading", true);

			if (this.user.avatar) {
				res = await this.deleteAvatar(true);
			}

			if (!this.user.avatar || res.success) {
				res = await this.postImage(img);
			}

			res = await this.setAvatar(res.data.token);

			if (res.success) {
				this.isSuccess = true;
			} else {
				this.isError = true;
			}
		},

		async setAvatar(token) {
			let res;
			await axios
				.post("users/manage-files", { avatar_token: token })
				.then((response) => {
					res = {
						success: true,
					};

					this.$store.commit("auth/setAvatar", response.data.data[0]);
					this.$store.commit("auth/setAvatarLoading", false);
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};
				});
			return res;
		},

		async deleteAvatar(isUpdate) {
			let res;
			await axios
				.post("users/manage-files", { delete_avatar: true })
				.then(() => {
					res = {
						success: true,
					};

					if (!isUpdate) {
						this.isSuccess = true;
					}

					this.$store.commit("auth/setAvatar", null);
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};

					if (!isUpdate) {
						this.isError = true;
					}
				});
			return res;
		},

		async postImage(img) {
			let res;
			await axios
				.post(`files`, { type: "image", for: "user_avatar", file: encodeURIComponent(img) })
				.then((response) => {
					res = {
						success: true,
						data: response.data.data,
					};
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};
				});
			return res;
		},
	},
};
</script>
